var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotification") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-26.000000, -83.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9093646,99.516129 L26.3960152,99.516129 C26.2535696,99.516129 26.1214365,99.4398158 26.0509927,99.3163506 C25.9813279,99.1936596 25.982923,99.0418442 26.0565199,98.9207384 L27.4160961,96.66983 C28.0428566,95.6309009 28.3744506,94.4417418 28.3744506,93.2297624 L28.3744506,91.2580424 C28.3744506,88.7569025 30.0625496,86.6392549 32.3655914,85.9716338 L32.3655914,84.6057473 C32.3655914,83.720172 33.0600376,83 33.9139785,83 C34.7679194,83 35.4623656,83.720172 35.4623656,84.6057473 L35.4623656,85.9716282 C37.7654172,86.6392431 39.4535256,88.7568955 39.4535256,91.2580424 L39.4535256,93.2297624 C39.4535256,94.4417418 39.7851196,95.6309009 40.4118801,96.66983 L41.7714563,98.9207384 C41.8450532,99.0418442 41.8466112,99.1936227 41.7769464,99.3163506 C41.7065397,99.4398527 41.5743695,99.516129 41.4319239,99.516129 L35.7465493,99.516129 C35.786132,99.6697646 35.8064516,99.8285969 35.8064516,99.9889671 C35.8048571,101.056717 34.9180851,101.924731 33.8271783,101.924731 C32.7362715,101.924731 31.8494994,101.056717 31.8494624,99.9889671 C31.8494624,99.8285969 31.869782,99.6697646 31.9093646,99.516129 Z",
    id: "icNotification"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotification);
export default __webpack_public_path__ + "static/media/icNotification.707c6d37362d2a7666bf05d42f9b82cd.svg";
export { ForwardRef as ReactComponent };